import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* contractChangeAutoSendInvoiceAutomatically(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_CONTRACT_AUTO_SEND_INVOICE_TO_TENANT_UPDATE_REQUEST
    });

    const res = yield call(Http.patch, `contract/${action.payload?.contractId}/set-auto-send-invoice-to-tenant`, {
      autoSendInvoiceToTenant: action.payload?.autoSendInvoiceToTenant,
      addressForRentEmail: action.payload?.addressForRentEmail
    });
   

    yield put({
      type: Constants.GLOBAL_CONTRACT_AUTO_SEND_INVOICE_TO_TENANT_UPDATE_SUCCESS
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res?.data);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_CONTRACT_AUTO_SEND_INVOICE_TO_TENANT_UPDATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchContractChangeAutoSendInvoiceAutomatically() {
  yield takeEvery(Constants.GLOBAL_CONTRACT_AUTO_SEND_INVOICE_TO_TENANT_UPDATE_START, contractChangeAutoSendInvoiceAutomatically);
}
